import { z } from 'zod';

import { getJobFormFileSchema } from './sharedSchemas';
import { promoNameInvalidMsg, promoNameRequiredMsg } from './validationErrors';

// A single or multi-word string with alphanumeric characters and specific symbols (., _, -), ensuring words are space-separated if multiple.
export const promoOfferNameRegEx = /^[A-Za-z0-9._-]+(?: [A-Za-z0-9._-]+)*$/;

const MAX_FILE_SIZE = 1 * 1024 * 1024; // 2MB

const promoNameSchema = z
    .string({
        error: issue => (issue.input === undefined ? promoNameRequiredMsg : undefined),
    })
    .trim()
    .min(1, promoNameInvalidMsg)
    .max(128, promoNameInvalidMsg)
    .regex(promoOfferNameRegEx, promoNameInvalidMsg);

const skusFileSchema = getJobFormFileSchema(MAX_FILE_SIZE);

export const promoEditorSchema = z.object({
    skusFile: skusFileSchema,
    promoName: promoNameSchema,
});

export const promoEditorRemoveAllSchema = z.object({
    promoName: promoNameSchema,
});
